import { useEffect, useState } from "react"
import { Row, Col, Button, Typography, Tooltip } from 'antd'
import { addOnTests } from "../../data/addOnTests.data"
import { ArrowRightOutlined } from '@ant-design/icons'
import { listTests } from "../../services/test.service"
import { useNavigate } from "react-router-dom";
import "./addOnTests.scss"
import { PgFooter } from "../pgFooter/pgFooter.component"
import FlowType from "../../enums/flowType.enum"

const { Paragraph } = Typography

const AddOnTests = () => {
  const navigate = useNavigate()
  const [tests, setTests] = useState()

  useEffect(() => {
    fetchTests()
    setDocumentTitle()
  }, [])

  const setDocumentTitle = () => {
    document.title = 'Add-on Tests | Instalab'
  }

  const fetchTests = async () => {
    const response = await listTests()
    setTests(response)
  }

  const getTest = code => {
    return tests.find(t => t.code === code)
  }

  const onScheduleBloodDraw = () => {
    navigate(`/flow/${FlowType.LONGEVITY_TEST}`)
  }

  return tests?.length > 0 && (
    <div className="biomarker-panel">
      <div className="panel-header">
        <Paragraph className="panel-title">
          Add-On Tests
        </Paragraph>

        <Paragraph className="panel-subtitle">
          These tests are available to add on to your <a className="cta-link" href="/longevity-panel">Longevity Panel</a>. If you're interested in adding them on or want something else not on this list, email support@instalab.com.
        </Paragraph>

        <Button 
          type='primary'
          className="main-cta-btn"
          onClick={onScheduleBloodDraw}
        >
          Schedule Blood Draw <ArrowRightOutlined />
        </Button>
      </div>

      <div className="category-list">
        {Object.keys(addOnTests).map(category => (
          <div 
            key={`category-${category._id}`}
            className="category-item"
          >
            <div className="category-item-content">
              <Row>
                <Col 
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 10 }}
                  lg={{ span: 10 }}
                  xl={{ span: 10 }}
                  xxl={{ span: 10 }}
                >
                  <Paragraph className="category-title">
                    {category}
                  </Paragraph>
                </Col>

                <Col
                  xs={{ span: 24 }}
                  sm={{ span: 24 }}
                  md={{ span: 14 }}
                  lg={{ span: 14 }}
                  xl={{ span: 14 }}
                  xxl={{ span: 14 }}
                >
                  <Row>
                    {addOnTests[category].map(testCode => (
                      <Col 
                        key={`test-${testCode}`} 
                        span={12}
                      >
                        <Tooltip title={getTest(testCode)?.tagline} placement='topLeft'>
                          <div className="category-test">
                            {getTest(testCode)?.name.replace(/\(Right\)/g, '').replace(/\(Systolic\)/g, '')}
                     
                          </div>
                        </Tooltip>
                      </Col>
                    ))}
                  </Row>
                </Col>
              </Row>
            </div>
          </div>
        ))}
      </div>

      <PgFooter />
    </div>
  )
}

export default AddOnTests